(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["p1s-common-react"] = factory(require("react"));
	else
		root["p1s-common-react"] = factory(root["React"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__442__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 442:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__442__;

/***/ }),

/***/ 368:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
  'use strict';

  var hasOwn = {}.hasOwnProperty;
  function classNames() {
    var classes = '';
    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (arg) {
        classes = appendClass(classes, parseValue(arg));
      }
    }
    return classes;
  }
  function parseValue(arg) {
    if (typeof arg === 'string' || typeof arg === 'number') {
      return arg;
    }
    if (typeof arg !== 'object') {
      return '';
    }
    if (Array.isArray(arg)) {
      return classNames.apply(null, arg);
    }
    if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
      return arg.toString();
    }
    var classes = '';
    for (var key in arg) {
      if (hasOwn.call(arg, key) && arg[key]) {
        classes = appendClass(classes, key);
      }
    }
    return classes;
  }
  function appendClass(value, newClass) {
    if (!newClass) {
      return value;
    }
    if (value) {
      return value + ' ' + newClass;
    }
    return value + newClass;
  }
  if ( true && module.exports) {
    classNames.default = classNames;
    module.exports = classNames;
  } else if (true) {
    // register as 'classnames', consistent with npm package name
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return classNames;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})();

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AppSelectorInfo: () => (/* reexport */ AppSelectorInfo),
  ApplicationItem: () => (/* reexport */ ApplicationItem),
  AvailableVirtualContent: () => (/* reexport */ AvailableVirtualContent),
  Banner: () => (/* reexport */ Banner),
  BaseClass: () => (/* reexport */ BaseClass),
  Contact: () => (/* reexport */ Contact),
  ExternalIdentifiers: () => (/* reexport */ ExternalIdentifiers),
  Icon: () => (/* reexport */ Icon),
  IconTypes: () => (/* reexport */ IconTypes),
  LinkItem: () => (/* reexport */ LinkItem),
  NabpRole: () => (/* reexport */ NabpRole),
  NavigationMenuGroup: () => (/* reexport */ NavigationMenuGroup),
  Organization: () => (/* reexport */ Organization),
  Permission: () => (/* reexport */ Permission),
  Product: () => (/* reexport */ Product),
  Tag: () => (/* reexport */ Tag),
  TimeZonePreference: () => (/* reexport */ TimeZonePreference),
  UnverifiedEmail: () => (/* reexport */ UnverifiedEmail),
  User: () => (/* reexport */ User)
});

;// CONCATENATED MODULE: ./src/entities/AppSelectorInfo.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var AppSelectorInfo = /*#__PURE__*/_createClass(function AppSelectorInfo(id, name, title) {
  _classCallCheck(this, AppSelectorInfo);
  this.id = id;
  this.name = name;
  this.title = title;
});

;// CONCATENATED MODULE: ./src/constants/OrganizationTypeEnum.js
var OrganizationTypeEnum = {
  Separate: "separate",
  Subordinate: "subordinate",
  Parent: "parent",
  P1S: "p1s"
};
/* harmony default export */ const constants_OrganizationTypeEnum = (OrganizationTypeEnum);
;// CONCATENATED MODULE: ./src/constants/OrganizationStatusEnum.js
var OrganizationStatusEnum = {
  Active: {
    value: "Active",
    label: "Active"
  },
  Locked: {
    value: "Locked",
    label: "Locked"
  },
  SuperUsersOnly: {
    value: "SuperUsersOnly",
    label: "Superuser Only"
  }
};
/* harmony default export */ const constants_OrganizationStatusEnum = (OrganizationStatusEnum);
;// CONCATENATED MODULE: ./src/constants/AuthenticationTypeEnum.js
var AuthenticationTypeEnum = {
  User: {
    value: "User",
    label: "Site/User/Password",
    text: "Site/User/Password",
    description: "Users log in with site number, user number, and password.",
    iconClass: "material-icons",
    materialIcon: "settings_input_component"
  },
  Sso: {
    value: "Sso",
    label: "Single Sign-On",
    text: "SSO",
    description: "Users log in using credentials managed by their organization.",
    iconClass: "material-icons",
    materialIcon: "vpn_key"
  },
  Password: {
    value: "Password",
    label: "Password",
    text: "Password",
    description: "Users log in using passwords they create and manage themselves.",
    iconClass: "material-icons",
    materialIcon: "lock"
  }
};
var getAuthenticationTypeByValue = function getAuthenticationTypeByValue(value) {
  var authenticationType = null;
  switch (value) {
    case AuthenticationTypeEnum.User.value:
      authenticationType = AuthenticationTypeEnum.User;
      break;
    case AuthenticationTypeEnum.Sso.value:
      authenticationType = AuthenticationTypeEnum.Sso;
      break;
    case AuthenticationTypeEnum.Password.value:
      authenticationType = AuthenticationTypeEnum.Password;
      break;
  }
  return authenticationType;
};
/* harmony default export */ const constants_AuthenticationTypeEnum = (AuthenticationTypeEnum);
;// CONCATENATED MODULE: ./src/utilities/OrganizationUtilities.js
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }




var getOrganizationType = function getOrganizationType(typeValue) {
  if (typeValue && typeValue.length > 0) {
    switch (typeValue.toLowerCase()) {
      case constants_OrganizationTypeEnum.P1S:
        return constants_OrganizationTypeEnum.P1S;
      case constants_OrganizationTypeEnum.Parent:
        return constants_OrganizationTypeEnum.Parent;
      case constants_OrganizationTypeEnum.Separate:
        return constants_OrganizationTypeEnum.Separate;
      case constants_OrganizationTypeEnum.Subordinate:
        return constants_OrganizationTypeEnum.Subordinate;
    }
  }
  return null;
};
var getOrganizationStatus = function getOrganizationStatus(value) {
  var organizationStatus;
  switch (value) {
    case constants_OrganizationStatusEnum.Active.value:
      organizationStatus = constants_OrganizationStatusEnum.Active;
      break;
    case constants_OrganizationStatusEnum.Locked.value:
      organizationStatus = constants_OrganizationStatusEnum.Locked;
      break;
    case constants_OrganizationStatusEnum.SuperUsersOnly.value:
      organizationStatus = constants_OrganizationStatusEnum.SuperUsersOnly;
      break;
  }
  return organizationStatus;
};
var OrganizationUtilities_getAuthenticationType = function getAuthenticationType(value) {
  var authenticationType = null;
  switch (value) {
    case constants_AuthenticationTypeEnum.User.value:
      authenticationType = constants_AuthenticationTypeEnum.User;
      break;
    case constants_AuthenticationTypeEnum.Sso.value:
      authenticationType = constants_AuthenticationTypeEnum.Sso;
      break;
    case constants_AuthenticationTypeEnum.Password.value:
      authenticationType = constants_AuthenticationTypeEnum.Password;
      break;
  }
  return authenticationType;
};
var createTreeList = function createTreeList(organizations) {
  var result = [];
  organizations.filter(function (o) {
    return !o.isSuborganization();
  }).forEach(function (organization) {
    result = [].concat(_toConsumableArray(result), [organization]);
    if (organization.isIDN()) {
      organization.suborganizations = organizations.filter(function (o) {
        return o.parentOrganizationId === organization.id;
      }).sort(sortByName);
    }
  });
  var notSubordinateIds = result.map(function (o) {
    return o.id;
  });
  var organizationsWithoutParent = organizations.filter(function (o) {
    return o.isSuborganization() && !notSubordinateIds.includes(o.parentOrganizationId);
  });
  result = [].concat(_toConsumableArray(result), _toConsumableArray(organizationsWithoutParent)).sort(sortByName);
  if (result.length === 0 && organizations.length > 0) return organizations;
  return result;
};
var getTags = function getTags(organizations) {
  var tags = [];
  organizations.forEach(function (organization) {
    tags = tags.concat(organization.tags);
    if (organizations.suborganizations) {
      organizations.suborganizations.forEach(function (subOrganization) {
        tags = tags.concat(subOrganization.tags);
      });
    }
  });
  return _toConsumableArray(new Set(tags));
};
var getCurrentP1s = function getCurrentP1s(organizations) {
  return organizations.find(function (o) {
    return o.site === 1;
  });
};
var getCurrentIdn = function getCurrentIdn(organizations, currentOrganization) {
  if (!currentOrganization) return undefined;
  if (currentOrganization.isSuborganization()) {
    var parent = organizations.find(function (org) {
      return org.id === currentOrganization.parentOrganizationId;
    });
    return parent ? parent : currentOrganization;
  }
  return currentOrganization;
};
;// CONCATENATED MODULE: ./src/entities/Product.js
function Product_typeof(o) { "@babel/helpers - typeof"; return Product_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Product_typeof(o); }
function Product_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Product_toPropertyKey(o.key), o); } }
function Product_createClass(e, r, t) { return r && Product_defineProperties(e.prototype, r), t && Product_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Product_toPropertyKey(t) { var i = Product_toPrimitive(t, "string"); return "symbol" == Product_typeof(i) ? i : i + ""; }
function Product_toPrimitive(t, r) { if ("object" != Product_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Product_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function Product_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var Product = /*#__PURE__*/Product_createClass(function Product(json) {
  Product_classCallCheck(this, Product);
  if (json) {
    this.id = json.Id;
    this.name = json.Name;
    this.order = json.Order;
    this.status = json.Status;
  }
});

;// CONCATENATED MODULE: ./src/utilities/SortingUtilities.js
function SortingUtilities_typeof(o) { "@babel/helpers - typeof"; return SortingUtilities_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, SortingUtilities_typeof(o); }
var SortingUtilities_sortByName = function sortByName(item1, item2, order) {
  return sortByField(item1, item2, order, "name");
};
var sortByOrder = function sortByOrder(item1, item2, order) {
  return sortByField(item1, item2, order, "order");
};
var sortByFields = function sortByFields(item1, item2, fields) {
  if (fields && fields.length > 0) {
    var result = 0;
    fields.forEach(function (field) {
      if (result == 0) {
        var fieldName = field.name ? field.name : field;
        var fieldOrder = field.order;
        result = sortByField(item1, item2, fieldOrder, fieldName);
      }
    });
    return result;
  }
  return -1;
};
var sortByDueDate = function sortByDueDate(item1, item2, order) {
  return sortByField(item1, item2, order, "dueAtTime");
};
var sortByField = function sortByField(item1, item2, order, field) {
  var value1 = field ? item1[field] : item1;
  var value2 = field ? item2[field] : item2;
  if (value1 == value2) return 0;
  var orderByDesc = order && order.toLowerCase() === "desc";
  // believe that undefined is the lowest
  if (value1 == undefined) return orderByDesc ? 1 : -1;
  if (value2 == undefined) return orderByDesc ? -1 : 1;
  if (SortingUtilities_typeof(value1) != SortingUtilities_typeof(value2)) return sortByString(SortingUtilities_typeof(value1), SortingUtilities_typeof(value2), order);
  if (typeof value1 == "boolean") return sortByBoolean(value1, value2, order);
  if (typeof value1 == "string") return sortByString(value1, value2, order);
  if (typeof value1 == "number") return sortByNumber(value1, value2, order);
  if (value1 instanceof Date) return sortByDate(value1, value2, order);
};
var sortByBoolean = function sortByBoolean(value1, value2, order) {
  if (value1 == value2) return 0;
  var result = 1;
  if (order && order.toLowerCase() === "desc") result = -1;
  if (value1 && !value2) {
    return result;
  }
  if (!value1 && value2) {
    return -result;
  }
  return 0;
};
var sortByString = function sortByString(value1, value2, order) {
  if (value1 == undefined && value2 == undefined) return 0;
  var orderByDesc = order && order.toLowerCase() === "desc";

  // believe that undefined is the lowest
  if (value1 == undefined) return orderByDesc ? 1 : -1;
  if (value2 == undefined) return orderByDesc ? -1 : 1;
  if (value1.toLowerCase() == value2.toLowerCase()) return 0;
  var result = orderByDesc ? -1 : 1;
  return value1.toLowerCase() > value2.toLowerCase() ? result : -result;
};
var sortByNumber = function sortByNumber(value1, value2, order) {
  if (value1 == value2) return 0;
  var orderByDesc = order && order.toLowerCase() === "desc";

  // believe that undefined is the lowest
  if (value1 == undefined) return orderByDesc ? 1 : -1;
  if (value2 == undefined) return orderByDesc ? -1 : 1;
  var result = orderByDesc ? -1 : 1;
  return value1 > value2 ? result : -result;
};
var sortByDate = function sortByDate(value1, value2, order) {
  if (value1 == value2) return 0;
  if (value1 instanceof Date && value2 instanceof Date) {
    if (value1.getTime() === value2.getTime()) return 0;
  }
  var orderByDesc = order && order.toLowerCase() === "desc";
  var result = orderByDesc ? -1 : 1;

  // believe that undefined is the lowest
  if (value1 == undefined) return -result;
  if (value2 == undefined) return result;
  return value1 > value2 ? result : -result;
};
var sortByNameAsc = function sortByNameAsc(a, b) {
  return SortingUtilities_sortByName(a, b, "asc");
};
var sortStringByFieldAsc = function sortStringByFieldAsc(a, b, field) {
  return a[field] == "" || a[field].toLowerCase() > b[field].toLowerCase() ? 1 : -1;
};
;// CONCATENATED MODULE: ./src/entities/BaseClass.js
function BaseClass_typeof(o) { "@babel/helpers - typeof"; return BaseClass_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, BaseClass_typeof(o); }
function BaseClass_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function BaseClass_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, BaseClass_toPropertyKey(o.key), o); } }
function BaseClass_createClass(e, r, t) { return r && BaseClass_defineProperties(e.prototype, r), t && BaseClass_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function BaseClass_toPropertyKey(t) { var i = BaseClass_toPrimitive(t, "string"); return "symbol" == BaseClass_typeof(i) ? i : i + ""; }
function BaseClass_toPrimitive(t, r) { if ("object" != BaseClass_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != BaseClass_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BaseClass = /*#__PURE__*/function () {
  function BaseClass() {
    BaseClass_classCallCheck(this, BaseClass);
  }
  return BaseClass_createClass(BaseClass, [{
    key: "createCopy",
    value: function createCopy() {
      var copy = new this.__proto__.constructor();
      for (var attr in this) {
        // eslint-disable-next-line no-use-before-define,no-prototype-builtins
        if (this.hasOwnProperty(attr)) {
          if (this[attr] instanceof Array) {
            copy[attr] = this[attr].map(function (item) {
              return getCopy(item);
            });
          } else {
            copy[attr] = getCopy(this[attr]);
          }
        }
      }
      return copy;
    }
  }]);
}();

var getCopy = function getCopy(item) {
  if (item instanceof BaseClass) {
    return item.createCopy();
  } else return item;
};
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/entities/Icon.js
function Icon_typeof(o) { "@babel/helpers - typeof"; return Icon_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Icon_typeof(o); }
function Icon_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Icon_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Icon_toPropertyKey(o.key), o); } }
function Icon_createClass(e, r, t) { return r && Icon_defineProperties(e.prototype, r), t && Icon_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = Icon_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Icon_toPropertyKey(t) { var i = Icon_toPrimitive(t, "string"); return "symbol" == Icon_typeof(i) ? i : i + ""; }
function Icon_toPrimitive(t, r) { if ("object" != Icon_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Icon_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var IconTypes = {
  "default": 0,
  material: 1,
  jumpstart: 2,
  svg: 3
};
var Icon = /*#__PURE__*/function () {
  function Icon(name) {
    var _this = this;
    var iconType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : IconTypes["default"];
    var extraClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    Icon_classCallCheck(this, Icon);
    _defineProperty(this, "addClasses", function (extraClasses) {
      return _this.extraClass = classnames_default()(_this.extraClass, extraClasses);
    });
    this.name = name;
    this.iconType = iconType;
    this.extraClass = extraClass;
  }

  /**
   * @deprecated use IconView
   */
  return Icon_createClass(Icon, [{
    key: "isMaterial",
    get: function get() {
      return this.iconType === IconTypes.material;
    }
  }]);
}();

// EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(442);
var external_root_React_commonjs2_react_commonjs_react_amd_react_default = /*#__PURE__*/__webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_);
;// CONCATENATED MODULE: ./src/constants/ProductTypeEnum.js
var ProductType = {
  surveillance: 0,
  safety: 1,
  tools: 2
};
/* harmony default export */ const ProductTypeEnum = (ProductType);
;// CONCATENATED MODULE: ./src/constants/ProductEnum.js



var productIds = {
  pharmacyProductId: 1,
  quantifyProductId: 2,
  infectionPreventionProductId: 3,
  veriFormProductId: 4,
  ruleProductId: 5,
  analyticsProductId: 6,
  simplifiProductId: 7,
  pocAdvisorProductId: 8,
  medStorageProductId: 9,
  sepsisMonitorProductId: 10,
  medTraysProductId: 11,
  patientDecompensationId: 12,
  documentationProductId: 13,
  aurReportingProductId: 14,
  flowlyticsProductId: 15,
  ivWorkflowProductId: 16,
  userManagementProductId: 99,
  superUserProductId: 101
};

// structure of enum:
//         id -  product id in Identifi, should be the same in all applications
//         name -  name of product,
//         abbreviation -
//         type - type of product (for grouping),
//         icon - object of type Icon like new Icon("icon-pill"),
//         iconContainerClass - class of patent element,
//         label - visible product name in left menu (if there is no override in "leftMenuLabel") and in Product Selector in Identifi,
//         iconClass - string of icon class name in Identifi (Product Selector),
//         iconName - string of icon name in Identifi (Product Selector),
//         tileClassName - class name for tile in Identifi Product Selector,
//         leftMenuLabel - visible product name in left menu
//         ariaLabel - aria-label attribute
var ProductEnum = {
  Pharmacy: {
    id: productIds.pharmacyProductId,
    name: "Sentri7 Pharmacy",
    abbreviation: "s7",
    type: ProductTypeEnum.surveillance,
    icon: new Icon("icon-pill"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Pharmacy"),
    iconClass: "custom-icon icon-pill",
    tileClassName: "pharmacy"
  },
  Quantifi: {
    id: productIds.quantifyProductId,
    name: "Quantifi",
    abbreviation: "q",
    type: ProductTypeEnum.surveillance,
    icon: new Icon("ion-md-stats"),
    iconContainerClass: "icon-product",
    iconClass: "icon ion-stats-bars",
    tileClassName: "quantifi",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Quantifi", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"))
  },
  InfectionPrevention: {
    id: productIds.infectionPreventionProductId,
    name: "Sentri7 Infection Prevention",
    abbreviation: "s7",
    type: ProductTypeEnum.surveillance,
    icon: new Icon("ion-md-bug"),
    iconContainerClass: "icon-product",
    iconClass: "icon bug_report",
    tileClassName: "ip",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Infection Prevention")
  },
  Veriform: {
    id: productIds.veriFormProductId,
    name: "Veriform",
    abbreviation: "v",
    type: ProductTypeEnum.safety,
    icon: new Icon("ion-md-clipboard"),
    iconContainerClass: "icon-product",
    iconClass: "custom-icon list-alt--outline",
    tileClassName: "veriform",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "VeriForm", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"))
  },
  Simplifi: {
    id: productIds.simplifiProductId,
    name: "Simplifi 797",
    abbreviation: "s",
    type: ProductTypeEnum.safety,
    icon: new Icon("icon-syringe"),
    iconContainerClass: "icon-product",
    iconClass: "icon-syringe",
    tileClassName: "simplifi",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Simplifi 797", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"))
  },
  Analytics: {
    id: productIds.analyticsProductId,
    name: "Analytics",
    abbreviation: "a",
    type: ProductTypeEnum.tools,
    icon: new Icon("ion-md-pulse"),
    iconContainerClass: "permission-analytics",
    iconClass: "icon ion-ios-pulse-strong",
    tileClassName: "analytics",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Analytics")
  },
  UserManagement: {
    id: productIds.userManagementProductId,
    name: "Settings & User Management",
    abbreviation: "cm",
    type: ProductTypeEnum.tools,
    icon: new Icon("icon-cogs"),
    iconContainerClass: "permission-userManagement",
    iconClass: "icon settings",
    tileClassName: "admin",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Settings & User Management")
  },
  RuleManagement: {
    id: productIds.ruleProductId,
    name: "Rules Management",
    abbreviation: "rm",
    type: ProductTypeEnum.tools,
    icon: new Icon("widgets"),
    iconContainerClass: "permission-ruleManagement",
    iconClass: "icon widgets",
    tileClassName: "rules",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Rules Management")
  },
  PocAdvisor: {
    id: productIds.pocAdvisorProductId,
    name: "POC Advisor",
    abbreviation: "pa",
    type: ProductTypeEnum.surveillance,
    icon: new Icon("flag"),
    iconContainerClass: "icon-product",
    iconClass: "icon flag",
    tileClassName: "pocadvisor",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "POC Advisor", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"))
  },
  SuperUser: {
    id: productIds.superUserProductId,
    name: "Super User",
    abbreviation: "",
    type: ProductTypeEnum.tools,
    icon: new Icon("ion-ios-color-wand"),
    iconContainerClass: "icon-product",
    iconClass: "icon ion-ios-color-wand",
    tileClassName: "superuser",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Super User")
  },
  MedStorage: {
    id: productIds.medStorageProductId,
    name: "Simplifi+ MedStorage",
    abbreviation: "m",
    type: ProductTypeEnum.safety,
    icon: new Icon("checklist"),
    iconContainerClass: "icon-product",
    iconClass: "checklist",
    tileClassName: "med-storage",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Simplifi+", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"), " MedStorage"),
    leftMenuLabel: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "MedStorage"),
    ariaLabel: "Simplify Plus MedStorage"
  },
  MedTrays: {
    id: productIds.medTraysProductId,
    name: "Simplifi+ MedTrays",
    abbreviation: "mt",
    type: ProductTypeEnum.safety,
    icon: new Icon("view_quilt"),
    iconContainerClass: "icon-product med-trays",
    iconClass: "icon view_quilt",
    tileClassName: "med-trays",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Simplifi+", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"), " MedTrays"),
    leftMenuLabel: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "MedTrays"),
    ariaLabel: "Simplify Plus MedTrays"
  },
  SepsisMonitor: {
    id: productIds.sepsisMonitorProductId,
    name: "Sepsis Monitor",
    abbreviation: "fl",
    type: ProductTypeEnum.surveillance,
    icon: new Icon("custom-icon icon-policy"),
    iconContainerClass: "icon-product",
    iconClass: "custom-icon icon-policy",
    tileClassName: "sepsis-monitor",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Sepsis Monitor")
  },
  PatientDecompensation: {
    id: productIds.patientDecompensationId,
    name: "Pharmacy (New)",
    abbreviation: "pd",
    type: ProductTypeEnum.surveillance,
    // Icon name should be in pascal case for svg icons both here and in assets/svg as they will be converted to react components
    icon: new Icon("SvgPharmacyNew", IconTypes.svg, "pharmacy-new"),
    iconContainerClass: "icon-product",
    iconClass: "pharmacy-new",
    tileClassName: "pharmacy-new-tile",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Pharmacy (New)"),
    ariaLabel: "Pharmacy New"
  },
  AurReporting: {
    id: productIds.aurReportingProductId,
    name: "AUR Reporting",
    abbreviation: "aur",
    type: ProductTypeEnum.surveillance,
    iconClass: "material-symbols-outlined",
    icon: new Icon("icon-data-exploration"),
    iconContainerClass: "icon-product",
    tileClassName: "S7AurOnly",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "AUR Reporting")
  },
  Flowlytics: {
    id: productIds.flowlyticsProductId,
    name: "Drug Diversion",
    abbreviation: "fl",
    type: ProductTypeEnum.surveillance,
    icon: new Icon("icon-alt-route"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Drug Diversion"),
    iconClass: "material-symbols-outlined",
    tileClassName: "flowlytics"
  },
  IVWorkflow: {
    id: productIds.ivWorkflowProductId,
    name: "Simplifi+ IV Workflow",
    abbreviation: "ivw",
    type: ProductTypeEnum.safety,
    icon: new Icon("iv-workflow"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Simplifi+", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"), " IV Workflow"),
    iconClass: "iv-workflow",
    tileClassName: "ivWorkflow",
    ariaLabel: "Simplify Plus IV Workflow"
  }
};
/* harmony default export */ const constants_ProductEnum = (ProductEnum);
;// CONCATENATED MODULE: ./src/entities/Organization.js
function Organization_typeof(o) { "@babel/helpers - typeof"; return Organization_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Organization_typeof(o); }
function Organization_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Organization_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Organization_toPropertyKey(o.key), o); } }
function Organization_createClass(e, r, t) { return r && Organization_defineProperties(e.prototype, r), t && Organization_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Organization_toPropertyKey(t) { var i = Organization_toPrimitive(t, "string"); return "symbol" == Organization_typeof(i) ? i : i + ""; }
function Organization_toPrimitive(t, r) { if ("object" != Organization_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Organization_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == Organization_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }







var Organization = /*#__PURE__*/function (_BaseClass) {
  function Organization(json) {
    var _this;
    Organization_classCallCheck(this, Organization);
    _this = _callSuper(this, Organization);
    _this.address = {};
    _this.contact = {};
    _this.virtualProductIdsOfOrganizationAndSubordinates = [];
    _this.virtualProducts = [];
    _this.virtualProductIds = [];
    _this.virtualContentIds = [];
    _this.isDarwinInfrastructure = false;
    _this.tags = [];
    _this.decommissionedDate = null;
    _this.isDecommissioned = false;
    _this.isReportProblemInSepsisMonitorEnabled = false;
    _this.sonicUCompanyId = null;
    if (json) mapJsonToOrganization(json, _this);
    return _this;
  }
  _inherits(Organization, _BaseClass);
  return Organization_createClass(Organization, [{
    key: "isP1S",
    value: function isP1S() {
      return this.type == constants_OrganizationTypeEnum.P1S || !this.site;
    }
  }, {
    key: "isIDN",
    value: function isIDN() {
      return this.type == constants_OrganizationTypeEnum.Parent;
    }
  }, {
    key: "isSuborganization",
    value: function isSuborganization() {
      return this.type == constants_OrganizationTypeEnum.Subordinate;
    }
  }, {
    key: "isSeparateOrganization",
    value: function isSeparateOrganization() {
      return this.type == constants_OrganizationTypeEnum.Separate;
    }
  }, {
    key: "addressString",
    get: function get() {
      if (this.address) {
        var city = this.address.city ? this.address.city.trim() : "";
        var state = this.address.state ? this.address.state.trim() : "";
        var delimiter = city && state ? ", " : "";
        return city + delimiter + state;
      }
      return "";
    }
  }, {
    key: "getAddressToJson",
    value: function getAddressToJson() {
      if (this.address) return {
        City: this.address.city,
        Street: this.address.street,
        State: this.address.state,
        ZipCode: this.address.zipCode
      };
      return {};
    }
  }, {
    key: "getAuthenticationType",
    value: function getAuthenticationType() {
      if (this.authenticationType) return OrganizationUtilities_getAuthenticationType(this.authenticationType);
      return null;
    }
  }, {
    key: "hasAccessToRuleManagement",
    get: function get() {
      return this.virtualProductIds.some(function (id) {
        return id == constants_ProductEnum.RuleManagement.id;
      });
    }
  }, {
    key: "hasAccessToSimplifi",
    get: function get() {
      return this.virtualProductIds.some(function (id) {
        return id == Product.Simplifi.id;
      });
    }
  }, {
    key: "hasAccessToAnalytics",
    get: function get() {
      return this.virtualProductIds.some(function (id) {
        return id == Product.Analytics.id;
      });
    }
  }, {
    key: "isAvailableForRules",
    get: function get() {
      return this.hasAccessToRuleManagement && !this.isDisabled && this.status.value != constants_OrganizationStatusEnum.Locked.value;
    }
  }, {
    key: "toJson",
    value: function toJson(user, provisioningProfile, selectedProductsIds, hydraGridNumber) {
      var json = {};
      json.Name = this.name;
      json.SiloNumber = this.silo;
      json.IsDarwinInfrastructure = this.isDarwinInfrastructure;
      if (user) {
        json.DefaultUserFirstName = user.firstName;
        json.DefaultUserLastName = user.lastName;
        json.DefaultUserEmail = user.email;
        json.DefaultUserPassword = user.password;
      }
      if (this.parentOrganizationId) json.ParentOrganizationId = this.parentOrganizationId;
      if (this.address) {
        json.Address = {
          City: this.address.city,
          Street: this.address.street,
          State: this.address.state,
          ZipCode: this.address.zipCode
        };
      }
      if (this.id) json.Id = this.id;
      if (provisioningProfile) {
        json.ProvisioningProfile = provisioningProfile.id;
      }
      if (hydraGridNumber) {
        json.HydraGridNumber = hydraGridNumber;
      }
      json.VirtualProductIds = selectedProductsIds || [];
      return json;
    }
  }]);
}(BaseClass);

var mapJsonToOrganization = function mapJsonToOrganization(json, organization) {
  organization.id = json.Id;
  organization.name = json.Name;
  organization.site = json.Site;
  organization.parentOrganizationId = json.ParentOrganizationId;
  organization.parentOrganizationName = json.ParentOrganizationName;
  organization.activeLocationsCount = json.ActiveSubordinateOrganizationsCount || 0;
  organization.virtualUsersCount = json.VirtualUsersCount || 0;
  organization.address = {};
  organization.contact = {};
  organization.authenticationType = json.AuthenticationType;
  organization.virtualProductIds = json.VirtualProductIds;
  organization.virtualContentIds = json.VirtualContentIds;
  organization.isReportProblemInSepsisMonitorEnabled = json.IsReportProblemInSepsisMonitorEnabled;
  organization.sonicUCompanyId = json.SonicUCompanyId;
  organization.isDisabled = json.IsDisabled;
  organization.isDecommissioned = json.IsDecommissioned;
  organization.decommissionedDate = json.DecommissionedDate;
  if (json.VirtualProductIdsOfOrganizationAndSubordinates) {
    organization.virtualProductIdsOfOrganizationAndSubordinates = [];
    json.VirtualProductIdsOfOrganizationAndSubordinates.forEach(function (item) {
      organization.virtualProductIdsOfOrganizationAndSubordinates.push(item);
    });
  }
  if (json.VirtualProducts) {
    organization.virtualProducts = [];
    json.VirtualProducts.forEach(function (item) {
      organization.virtualProducts.push(new Product(item));
    });
  }
  if (json.Type) {
    organization.type = getOrganizationType(json.Type);
  }
  if (json.Status) {
    organization.status = getOrganizationStatus(json.Status);
  }
  if (json.Address) {
    organization.address = {
      city: json.Address.City,
      state: json.Address.State,
      street: json.Address.Street,
      zipCode: json.Address.ZipCode
    };
  }
  if (json.PrimaryContact) {
    organization.contact = {
      firstName: json.PrimaryContact.FirstName,
      lastName: json.PrimaryContact.LastName
    };
  }
  if (json.SiloView) {
    organization.silo = json.SiloView.Number;
    organization.isDarwinInfrastructure = !json.SiloView.Number;
  }
  if (json.Tags) organization.tags = json.Tags.sort(sortByString).slice();
};
;// CONCATENATED MODULE: ./src/entities/Permission.js
function Permission_typeof(o) { "@babel/helpers - typeof"; return Permission_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Permission_typeof(o); }
function Permission_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Permission_toPropertyKey(o.key), o); } }
function Permission_createClass(e, r, t) { return r && Permission_defineProperties(e.prototype, r), t && Permission_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Permission_toPropertyKey(t) { var i = Permission_toPrimitive(t, "string"); return "symbol" == Permission_typeof(i) ? i : i + ""; }
function Permission_toPrimitive(t, r) { if ("object" != Permission_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Permission_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function Permission_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var Permission = /*#__PURE__*/Permission_createClass(function Permission(json) {
  Permission_classCallCheck(this, Permission);
  if (json) {
    this.id = json.Id;
    this.name = json.Name;
  }
});

;// CONCATENATED MODULE: ./src/entities/UnverifiedEmail.js
function UnverifiedEmail_typeof(o) { "@babel/helpers - typeof"; return UnverifiedEmail_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, UnverifiedEmail_typeof(o); }
function UnverifiedEmail_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function UnverifiedEmail_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, UnverifiedEmail_toPropertyKey(o.key), o); } }
function UnverifiedEmail_createClass(e, r, t) { return r && UnverifiedEmail_defineProperties(e.prototype, r), t && UnverifiedEmail_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function UnverifiedEmail_toPropertyKey(t) { var i = UnverifiedEmail_toPrimitive(t, "string"); return "symbol" == UnverifiedEmail_typeof(i) ? i : i + ""; }
function UnverifiedEmail_toPrimitive(t, r) { if ("object" != UnverifiedEmail_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != UnverifiedEmail_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UnverifiedEmail = /*#__PURE__*/function () {
  function UnverifiedEmail(json) {
    UnverifiedEmail_classCallCheck(this, UnverifiedEmail);
    this.email = "";
    this.activatedDateTime = undefined;
    this.canBeDiscarded = false;
    if (json) mapJsonToObj(json, this);
  }
  return UnverifiedEmail_createClass(UnverifiedEmail, [{
    key: "toJson",
    value: function toJson() {
      var json = {};
      mapObjToJson(this, json);
      return json;
    }
  }]);
}();

var mapJsonToObj = function mapJsonToObj(json, unverifiedEmail) {
  unverifiedEmail.email = json.Email;
  unverifiedEmail.activatedDateTime = json.ActivatedDateTime;
  unverifiedEmail.canBeDiscarded = json.CanBeDiscarded;
};
var mapObjToJson = function mapObjToJson(unverifiedEmail, json) {
  json.Email = unverifiedEmail.email;
  json.ActivatedDateTime = unverifiedEmail.activatedDateTime;
  json.CanBeDiscarded = unverifiedEmail.canBeDiscarded;
};
;// CONCATENATED MODULE: ./src/utilities/ProductUtilities.js
var _ProductsMemo;
function ProductUtilities_typeof(o) { "@babel/helpers - typeof"; return ProductUtilities_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, ProductUtilities_typeof(o); }
function ProductUtilities_defineProperty(e, r, t) { return (r = ProductUtilities_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ProductUtilities_toPropertyKey(t) { var i = ProductUtilities_toPrimitive(t, "string"); return "symbol" == ProductUtilities_typeof(i) ? i : i + ""; }
function ProductUtilities_toPrimitive(t, r) { if ("object" != ProductUtilities_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != ProductUtilities_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ProductsMemo = (_ProductsMemo = {}, ProductUtilities_defineProperty(ProductUtilities_defineProperty(ProductUtilities_defineProperty(ProductUtilities_defineProperty(ProductUtilities_defineProperty(ProductUtilities_defineProperty(ProductUtilities_defineProperty(ProductUtilities_defineProperty(ProductUtilities_defineProperty(ProductUtilities_defineProperty(_ProductsMemo, constants_ProductEnum.Pharmacy.id, constants_ProductEnum.Pharmacy), constants_ProductEnum.InfectionPrevention.id, constants_ProductEnum.InfectionPrevention), constants_ProductEnum.RuleManagement.id, constants_ProductEnum.RuleManagement), constants_ProductEnum.SuperUser.id, constants_ProductEnum.SuperUser), constants_ProductEnum.Quantifi.id, constants_ProductEnum.Quantifi), constants_ProductEnum.Veriform.id, constants_ProductEnum.Veriform), constants_ProductEnum.PocAdvisor.id, constants_ProductEnum.PocAdvisor), constants_ProductEnum.MedStorage.id, constants_ProductEnum.MedStorage), constants_ProductEnum.Simplifi.id, constants_ProductEnum.Simplifi), constants_ProductEnum.MedTrays.id, constants_ProductEnum.MedTrays), ProductUtilities_defineProperty(ProductUtilities_defineProperty(ProductUtilities_defineProperty(ProductUtilities_defineProperty(ProductUtilities_defineProperty(ProductUtilities_defineProperty(ProductUtilities_defineProperty(_ProductsMemo, constants_ProductEnum.SepsisMonitor.id, constants_ProductEnum.SepsisMonitor), constants_ProductEnum.PatientDecompensation.id, constants_ProductEnum.PatientDecompensation), constants_ProductEnum.Analytics.id, constants_ProductEnum.Analytics), constants_ProductEnum.UserManagement.id, constants_ProductEnum.UserManagement), constants_ProductEnum.AurReporting.id, constants_ProductEnum.AurReporting), constants_ProductEnum.Flowlytics.id, constants_ProductEnum.Flowlytics), constants_ProductEnum.IVWorkflow.id, constants_ProductEnum.IVWorkflow));
var getProductConfigurationById = function getProductConfigurationById(productId) {
  return ProductsMemo[productId];
};
var isProductNeedsAnalytics = function isProductNeedsAnalytics(product) {
  return product.id === Products.Pharmacy.id || product.id === Products.InfectionPrevention.id || product.id === Products.RuleManagement.id;
};
var isSuperUserProduct = function isSuperUserProduct(product) {
  return product.id === Products.SuperUser.id;
};

// legacyProduct
var legacyProductIds = [constants_ProductEnum.Pharmacy.id, constants_ProductEnum.Quantifi.id, constants_ProductEnum.InfectionPrevention.id, constants_ProductEnum.Veriform.id];
var isLegacyProduct = function isLegacyProduct(productId) {
  return legacyProductIds.indexOf(productId) > -1;
};

// toolsProduct
var tools = [constants_ProductEnum.RuleManagement.id, constants_ProductEnum.Analytics.id, constants_ProductEnum.UserManagement.id, constants_ProductEnum.SuperUser.id];
var isTools = function isTools(productId) {
  return tools.indexOf(productId) > -1;
};

// surveillanceProduct
var surveillanceProductIds = [constants_ProductEnum.Pharmacy.id, constants_ProductEnum.Quantifi.id, constants_ProductEnum.InfectionPrevention.id, constants_ProductEnum.PocAdvisor.id, constants_ProductEnum.SepsisMonitor.id, constants_ProductEnum.PatientDecompensation.id, constants_ProductEnum.AurReporting.id, constants_ProductEnum.Flowlytics.id];
var isSurveillanceProduct = function isSurveillanceProduct(productId) {
  return surveillanceProductIds.indexOf(productId) > -1;
};

// safetyProduct
var safetyProductIds = [constants_ProductEnum.Veriform.id, constants_ProductEnum.MedStorage.id, constants_ProductEnum.Simplifi.id, constants_ProductEnum.MedTrays.id, constants_ProductEnum.IVWorkflow.id];
var isSafetyProduct = function isSafetyProduct(productId) {
  return safetyProductIds.indexOf(productId) > -1;
};
;// CONCATENATED MODULE: ./src/entities/Tag.js
function Tag_typeof(o) { "@babel/helpers - typeof"; return Tag_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Tag_typeof(o); }
function Tag_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Tag_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Tag_toPropertyKey(o.key), o); } }
function Tag_createClass(e, r, t) { return r && Tag_defineProperties(e.prototype, r), t && Tag_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Tag_toPropertyKey(t) { var i = Tag_toPrimitive(t, "string"); return "symbol" == Tag_typeof(i) ? i : i + ""; }
function Tag_toPrimitive(t, r) { if ("object" != Tag_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Tag_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Tag = /*#__PURE__*/function () {
  function Tag(json) {
    Tag_classCallCheck(this, Tag);
    this.id = -1;
    this.name = "";
    if (json) this.fromJson(json, this);
  }
  return Tag_createClass(Tag, [{
    key: "fromJson",
    value: function fromJson(json, tag) {
      tag.id = json.Id;
      tag.name = json.Name;
    }
  }, {
    key: "createCopy",
    value: function createCopy() {
      var tag = new Tag();
      tag.id = this.id;
      tag.name = this.name;
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/entities/ExternalIdentifiers.js
function ExternalIdentifiers_typeof(o) { "@babel/helpers - typeof"; return ExternalIdentifiers_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, ExternalIdentifiers_typeof(o); }
function ExternalIdentifiers_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function ExternalIdentifiers_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, ExternalIdentifiers_toPropertyKey(o.key), o); } }
function ExternalIdentifiers_createClass(e, r, t) { return r && ExternalIdentifiers_defineProperties(e.prototype, r), t && ExternalIdentifiers_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function ExternalIdentifiers_toPropertyKey(t) { var i = ExternalIdentifiers_toPrimitive(t, "string"); return "symbol" == ExternalIdentifiers_typeof(i) ? i : i + ""; }
function ExternalIdentifiers_toPrimitive(t, r) { if ("object" != ExternalIdentifiers_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != ExternalIdentifiers_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ExternalIdentifiers_callSuper(t, o, e) { return o = ExternalIdentifiers_getPrototypeOf(o), ExternalIdentifiers_possibleConstructorReturn(t, ExternalIdentifiers_isNativeReflectConstruct() ? Reflect.construct(o, e || [], ExternalIdentifiers_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function ExternalIdentifiers_possibleConstructorReturn(t, e) { if (e && ("object" == ExternalIdentifiers_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return ExternalIdentifiers_assertThisInitialized(t); }
function ExternalIdentifiers_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function ExternalIdentifiers_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ExternalIdentifiers_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ExternalIdentifiers_getPrototypeOf(t) { return ExternalIdentifiers_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, ExternalIdentifiers_getPrototypeOf(t); }
function ExternalIdentifiers_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && ExternalIdentifiers_setPrototypeOf(t, e); }
function ExternalIdentifiers_setPrototypeOf(t, e) { return ExternalIdentifiers_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, ExternalIdentifiers_setPrototypeOf(t, e); }

var ExternalIdentifiers = /*#__PURE__*/function (_BaseClass) {
  function ExternalIdentifiers(json) {
    var _this;
    ExternalIdentifiers_classCallCheck(this, ExternalIdentifiers);
    _this = ExternalIdentifiers_callSuper(this, ExternalIdentifiers);
    if (json) {
      _this.externalIdentifiersId = json.ExternalIdentifiersId;
      _this.nationalProviderIdentifier = json.NationalProviderIdentifier;
      _this.nabpEPid = json.NabpEPid;
      _this.dateOfBirth = json.DateOfBirth;
      _this.nabpRoleId = json.NabpRoleId;
      _this.hasNoNabp = json.HasNoNabp;
    }
    return _this;
  }
  ExternalIdentifiers_inherits(ExternalIdentifiers, _BaseClass);
  return ExternalIdentifiers_createClass(ExternalIdentifiers, [{
    key: "toJson",
    value: function toJson() {
      return {
        ExternalIdentifiersId: this.externalIdentifiersId,
        NationalProviderIdentifier: this.nationalProviderIdentifier,
        NabpEPid: this.nabpEPid,
        DateOfBirth: this.dateOfBirth,
        NabpRoleId: this.nabpRoleId,
        HasNoNabp: this.hasNoNabp
      };
    }
  }]);
}(BaseClass);

;// CONCATENATED MODULE: ./src/entities/User.js
function User_typeof(o) { "@babel/helpers - typeof"; return User_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, User_typeof(o); }
function User_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function User_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, User_toPropertyKey(o.key), o); } }
function User_createClass(e, r, t) { return r && User_defineProperties(e.prototype, r), t && User_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function User_toPropertyKey(t) { var i = User_toPrimitive(t, "string"); return "symbol" == User_typeof(i) ? i : i + ""; }
function User_toPrimitive(t, r) { if ("object" != User_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != User_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function User_callSuper(t, o, e) { return o = User_getPrototypeOf(o), User_possibleConstructorReturn(t, User_isNativeReflectConstruct() ? Reflect.construct(o, e || [], User_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function User_possibleConstructorReturn(t, e) { if (e && ("object" == User_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return User_assertThisInitialized(t); }
function User_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function User_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (User_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function User_getPrototypeOf(t) { return User_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, User_getPrototypeOf(t); }
function User_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && User_setPrototypeOf(t, e); }
function User_setPrototypeOf(t, e) { return User_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, User_setPrototypeOf(t, e); }










var User = /*#__PURE__*/function (_BaseClass) {
  function User(json) {
    var _this;
    User_classCallCheck(this, User);
    _this = User_callSuper(this, User);
    _this.firstName = "";
    _this.lastName = "";
    _this.email = "";
    _this.externalUserId = "";
    _this.isVirtualSuperUser = false;
    _this.hasAccessToEntireIdn = false;
    _this.activeOrganizations = [];
    _this.assignedVirtualProducts = [];
    _this.permissions = [];
    _this.organizationId = 0;
    _this.organizationName = "";
    _this.virtualProfileId = 0;
    _this.authType = "";
    _this.isActive = true;
    _this.pin = "";
    _this.pendingEmail = undefined;
    _this.isEmailLoginEnabled = false;
    _this.tags = [];
    _this.externalIdentifiers = null;
    if (json) mapJsonToUser(json, _this);
    return _this;
  }
  User_inherits(User, _BaseClass);
  return User_createClass(User, [{
    key: "getInitials",
    value: function getInitials() {
      if (this.isSystem) return "P1";else return this.firstName.substring(0, 1) + this.lastName.substring(0, 1);
    }
  }, {
    key: "fullName",
    get: function get() {
      return this.firstName + " " + this.lastName;
    }
  }, {
    key: "hasUnverifiedEmail",
    get: function get() {
      return this.pendingEmail ? true : false;
    }
  }, {
    key: "toJson",
    value: function toJson() {
      var json = {};
      mapUserToJson(this, json);
      return json;
    }
  }, {
    key: "canChangeLocation",
    get: function get() {
      return this.isVirtualSuperUser === true || this.activeOrganizations.length > 1;
    }
  }, {
    key: "hasSurveillanceProducts",
    get: function get() {
      return this.assignedVirtualProducts.filter(function (product) {
        return isSurveillanceProduct(product.id);
      });
    }
  }, {
    key: "hasSafetyProducts",
    get: function get() {
      return this.assignedVirtualProducts.filter(function (product) {
        return isSafetyProduct(product.id);
      });
    }
  }, {
    key: "hasTools",
    get: function get() {
      return this.assignedVirtualProducts.filter(function (product) {
        return isTools(product.id);
      });
    }
  }]);
}(BaseClass);

var mapJsonToUser = function mapJsonToUser(json, user) {
  user.id = json.Id;
  user.externalUserId = json.ExternalUserId;
  user.firstName = json.FirstName;
  user.lastName = json.LastName;
  user.email = json.Email;
  user.isActive = json.IsActive;
  user.organizationId = json.OrganizationId;
  user.organizationName = json.OrganizationName;
  user.virtualProfileId = json.VirtualProfileId;
  user.virtualProfileName = json.VirtualProfileName;
  user.isVirtualSuperUser = json.IsVirtualSuperUser;
  user.hasAccessToEntireIdn = json.HasAccessToEntireIdn;
  user.activeOrganizations = [];
  user.authType = json.AuthenticationType;
  user.pin = json.Pin;
  user.isEmailLoginEnabled = json.IsEmailLoginEnabled;
  if (json.AssignedOrganizations) {
    user.activeOrganizations = json.AssignedOrganizations.map(function (item) {
      return new Organization(item);
    }).sort(SortingUtilities_sortByName);
  }
  if (json.AssignedVirtualProducts) {
    json.AssignedVirtualProducts.forEach(function (item) {
      user.assignedVirtualProducts.push(new Product(item));
    });

    // TODO temporary
    if (json.HasAccessToUserManagement) {
      var userManagementProduct = new Product({
        Id: constants_ProductEnum.UserManagement.id,
        Name: constants_ProductEnum.UserManagement.name
      });
      user.assignedVirtualProducts.push(userManagementProduct);
    }
  }
  if (json.Permissions) {
    json.Permissions.forEach(function (item) {
      user.permissions.push(new Permission(item));
    });
  }
  if (json.PendingEmail) {
    user.pendingEmail = new UnverifiedEmail(json.PendingEmail);
  }
  if (json.Tags) {
    user.tags = json.Tags.map(function (tagJson) {
      return new Tag(tagJson);
    });
  }
  if (json.ExternalIdentifiers) {
    user.externalIdentifiers = new ExternalIdentifiers(json.ExternalIdentifiers);
  }
};
var mapUserToJson = function mapUserToJson(user, json) {
  json.Id = user.id;
  json.ExternalUserId = user.externalUserId;
  json.FirstName = user.firstName;
  json.LastName = user.lastName;
  json.Email = user.email;
  json.IsActive = user.isActive;
  json.OrganizationId = user.organizationId;
  json.OrganizationName = user.organizationName;
  json.VirtualProfileId = user.virtualProfileId;
  json.VirtualProfileName = user.virtualProfileName;
  json.IsVirtualSuperUser = user.isVirtualSuperUser;
  if (user.pendingEmail) {
    json.PendingEmail = user.pendingEmail.toJson();
  }
  if (user.externalIdentifiers) {
    json.ExternalIdentifiers = user.externalIdentifiers.toJson();
  }
  json.AssignedOrganizations = user.activeOrganizations.map(function (o) {
    return o.id;
  });
  json.AssignedVirtualProducts = user.assignedVirtualProducts.map(function (p) {
    return p.id;
  });
  json.Permissions = user.permissions.map(function (p) {
    return p.id;
  });
  json.Pin = user.pin;
  json.Tags = user.tags.map(function (p) {
    return p.id;
  });
};
;// CONCATENATED MODULE: ./src/entities/ApplicationItem.js
function ApplicationItem_typeof(o) { "@babel/helpers - typeof"; return ApplicationItem_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, ApplicationItem_typeof(o); }
function ApplicationItem_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, ApplicationItem_toPropertyKey(o.key), o); } }
function ApplicationItem_createClass(e, r, t) { return r && ApplicationItem_defineProperties(e.prototype, r), t && ApplicationItem_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function ApplicationItem_toPropertyKey(t) { var i = ApplicationItem_toPrimitive(t, "string"); return "symbol" == ApplicationItem_typeof(i) ? i : i + ""; }
function ApplicationItem_toPrimitive(t, r) { if ("object" != ApplicationItem_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != ApplicationItem_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ApplicationItem_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var ApplicationItem = /*#__PURE__*/ApplicationItem_createClass(function ApplicationItem(json) {
  ApplicationItem_classCallCheck(this, ApplicationItem);
  if (json) {
    this.id = json.Id;
    this.name = json.Name;
    this.type = json.Type;
    this.url = json.Url;
    this.isLocked = json.IsLocked;
  }
  return this;
});

;// CONCATENATED MODULE: ./src/entities/NavigationMenuGroup.js
function NavigationMenuGroup_typeof(o) { "@babel/helpers - typeof"; return NavigationMenuGroup_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, NavigationMenuGroup_typeof(o); }
function NavigationMenuGroup_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, NavigationMenuGroup_toPropertyKey(o.key), o); } }
function NavigationMenuGroup_createClass(e, r, t) { return r && NavigationMenuGroup_defineProperties(e.prototype, r), t && NavigationMenuGroup_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function NavigationMenuGroup_toPropertyKey(t) { var i = NavigationMenuGroup_toPrimitive(t, "string"); return "symbol" == NavigationMenuGroup_typeof(i) ? i : i + ""; }
function NavigationMenuGroup_toPrimitive(t, r) { if ("object" != NavigationMenuGroup_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != NavigationMenuGroup_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function NavigationMenuGroup_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var NavigationMenuGroup = /*#__PURE__*/NavigationMenuGroup_createClass(function NavigationMenuGroup() {
  var links = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main menu";
  NavigationMenuGroup_classCallCheck(this, NavigationMenuGroup);
  this.title = title;
  this.links = links;
});

;// CONCATENATED MODULE: ./src/entities/LinkItem.js
function LinkItem_typeof(o) { "@babel/helpers - typeof"; return LinkItem_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, LinkItem_typeof(o); }
function LinkItem_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function LinkItem_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, LinkItem_toPropertyKey(o.key), o); } }
function LinkItem_createClass(e, r, t) { return r && LinkItem_defineProperties(e.prototype, r), t && LinkItem_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function LinkItem_toPropertyKey(t) { var i = LinkItem_toPrimitive(t, "string"); return "symbol" == LinkItem_typeof(i) ? i : i + ""; }
function LinkItem_toPrimitive(t, r) { if ("object" != LinkItem_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != LinkItem_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LinkItem = /*#__PURE__*/function () {
  function LinkItem(title, url) {
    var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    LinkItem_classCallCheck(this, LinkItem);
    this.title = title;
    this.url = url;
    this.icon = icon;
  }
  return LinkItem_createClass(LinkItem, null, [{
    key: "fromJson",
    value: function fromJson(json) {
      var item = new LinkItem();
      item.title = json.title;
      item.url = json.url;
      item.icon = json.icon;
      return item;
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/entities/AvailableVirtualContent.js
function AvailableVirtualContent_typeof(o) { "@babel/helpers - typeof"; return AvailableVirtualContent_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, AvailableVirtualContent_typeof(o); }
function AvailableVirtualContent_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function AvailableVirtualContent_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, AvailableVirtualContent_toPropertyKey(o.key), o); } }
function AvailableVirtualContent_createClass(e, r, t) { return r && AvailableVirtualContent_defineProperties(e.prototype, r), t && AvailableVirtualContent_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function AvailableVirtualContent_toPropertyKey(t) { var i = AvailableVirtualContent_toPrimitive(t, "string"); return "symbol" == AvailableVirtualContent_typeof(i) ? i : i + ""; }
function AvailableVirtualContent_toPrimitive(t, r) { if ("object" != AvailableVirtualContent_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != AvailableVirtualContent_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AvailableVirtualContent = /*#__PURE__*/function () {
  function AvailableVirtualContent(json) {
    AvailableVirtualContent_classCallCheck(this, AvailableVirtualContent);
    if (json) {
      this.fromJson(json);
    }
  }
  return AvailableVirtualContent_createClass(AvailableVirtualContent, [{
    key: "fromJson",
    value: function fromJson(json) {
      this.id = json.Id;
      this.isSelected = json.IsSelected;
      this.name = json.Name;
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        Id: this.id,
        IsSelected: this.isSelected
      };
    }
  }, {
    key: "createCopy",
    value: function createCopy() {
      var content = new AvailableVirtualContent();
      content.id = this.id;
      content.isSelected = this.isSelected;
      content.name = this.name;
      return content;
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/entities/Contact.js
function Contact_typeof(o) { "@babel/helpers - typeof"; return Contact_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Contact_typeof(o); }
function Contact_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Contact_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Contact_toPropertyKey(o.key), o); } }
function Contact_createClass(e, r, t) { return r && Contact_defineProperties(e.prototype, r), t && Contact_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Contact_toPropertyKey(t) { var i = Contact_toPrimitive(t, "string"); return "symbol" == Contact_typeof(i) ? i : i + ""; }
function Contact_toPrimitive(t, r) { if ("object" != Contact_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Contact_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function Contact_callSuper(t, o, e) { return o = Contact_getPrototypeOf(o), Contact_possibleConstructorReturn(t, Contact_isNativeReflectConstruct() ? Reflect.construct(o, e || [], Contact_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function Contact_possibleConstructorReturn(t, e) { if (e && ("object" == Contact_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return Contact_assertThisInitialized(t); }
function Contact_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function Contact_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Contact_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function Contact_getPrototypeOf(t) { return Contact_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, Contact_getPrototypeOf(t); }
function Contact_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && Contact_setPrototypeOf(t, e); }
function Contact_setPrototypeOf(t, e) { return Contact_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, Contact_setPrototypeOf(t, e); }

var Contact = /*#__PURE__*/function (_BaseClass) {
  function Contact(json) {
    var _this;
    Contact_classCallCheck(this, Contact);
    _this = Contact_callSuper(this, Contact);
    _this.virtualUserId = null;
    _this.firstName = "";
    _this.lastName = "";
    _this.isSystem = false;
    if (json) {
      _this.fromJson(json, _this);
    }
    return _this;
  }
  Contact_inherits(Contact, _BaseClass);
  return Contact_createClass(Contact, [{
    key: "getFullName",
    value: function getFullName() {
      if (this.isSystem) return "Wolters Kluwer";else return this.firstName + " " + this.lastName;
    }
  }, {
    key: "getInitials",
    value: function getInitials() {
      if (this.isSystem) return "WK";else return this.firstName.substring(0, 1) + this.lastName.substring(0, 1);
    }
  }, {
    key: "fromJson",
    value: function fromJson(json, contact) {
      contact.virtualUserId = json.VirtualUserId;
      contact.firstName = json.FirstName;
      contact.lastName = json.LastName;
      contact.isSystem = json.IsSystem;
    }
  }]);
}(BaseClass);

;// CONCATENATED MODULE: ./src/entities/NabpRole.js
function NabpRole_typeof(o) { "@babel/helpers - typeof"; return NabpRole_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, NabpRole_typeof(o); }
function NabpRole_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function NabpRole_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, NabpRole_toPropertyKey(o.key), o); } }
function NabpRole_createClass(e, r, t) { return r && NabpRole_defineProperties(e.prototype, r), t && NabpRole_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function NabpRole_toPropertyKey(t) { var i = NabpRole_toPrimitive(t, "string"); return "symbol" == NabpRole_typeof(i) ? i : i + ""; }
function NabpRole_toPrimitive(t, r) { if ("object" != NabpRole_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != NabpRole_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NabpRole = /*#__PURE__*/function () {
  function NabpRole(json) {
    NabpRole_classCallCheck(this, NabpRole);
    if (json) {
      this.fromJson(json, this);
    }
  }
  return NabpRole_createClass(NabpRole, [{
    key: "fromJson",
    value: function fromJson(json, role) {
      role.nabpRoleId = json.NabpRoleId;
      role.name = json.Name;
      role.rank = json.Rank;
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/entities/TimeZonePreference.js
function TimeZonePreference_typeof(o) { "@babel/helpers - typeof"; return TimeZonePreference_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, TimeZonePreference_typeof(o); }
function TimeZonePreference_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function TimeZonePreference_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, TimeZonePreference_toPropertyKey(o.key), o); } }
function TimeZonePreference_createClass(e, r, t) { return r && TimeZonePreference_defineProperties(e.prototype, r), t && TimeZonePreference_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function TimeZonePreference_toPropertyKey(t) { var i = TimeZonePreference_toPrimitive(t, "string"); return "symbol" == TimeZonePreference_typeof(i) ? i : i + ""; }
function TimeZonePreference_toPrimitive(t, r) { if ("object" != TimeZonePreference_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != TimeZonePreference_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TimeZonePreference = /*#__PURE__*/function () {
  function TimeZonePreference(json) {
    TimeZonePreference_classCallCheck(this, TimeZonePreference);
    this.organizationId = -1;
    this.timeZone = "";
    this.isDstEnabled = true;
    if (json) mapJsonToPreference(json, this);
  }
  return TimeZonePreference_createClass(TimeZonePreference, null, [{
    key: "createDefault",
    value: function createDefault() {
      var preference = new TimeZonePreference();
      preference.organizationId = -1;
      preference.timeZone = "";
      preference.isDstEnabled = true;
      return preference;
    }
  }]);
}();

var mapJsonToPreference = function mapJsonToPreference(json, preference) {
  preference.organizationId = json.OrgId;
  preference.timeZone = json.TimeZone;
  preference.isDstEnabled = json.IsDstEnabled;
};
;// CONCATENATED MODULE: ./src/entities/Banner.js
function Banner_typeof(o) { "@babel/helpers - typeof"; return Banner_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Banner_typeof(o); }
function Banner_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Banner_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Banner_toPropertyKey(o.key), o); } }
function Banner_createClass(e, r, t) { return r && Banner_defineProperties(e.prototype, r), t && Banner_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Banner_toPropertyKey(t) { var i = Banner_toPrimitive(t, "string"); return "symbol" == Banner_typeof(i) ? i : i + ""; }
function Banner_toPrimitive(t, r) { if ("object" != Banner_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Banner_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function Banner_callSuper(t, o, e) { return o = Banner_getPrototypeOf(o), Banner_possibleConstructorReturn(t, Banner_isNativeReflectConstruct() ? Reflect.construct(o, e || [], Banner_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function Banner_possibleConstructorReturn(t, e) { if (e && ("object" == Banner_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return Banner_assertThisInitialized(t); }
function Banner_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function Banner_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Banner_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function Banner_getPrototypeOf(t) { return Banner_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, Banner_getPrototypeOf(t); }
function Banner_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && Banner_setPrototypeOf(t, e); }
function Banner_setPrototypeOf(t, e) { return Banner_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, Banner_setPrototypeOf(t, e); }

var Banner = /*#__PURE__*/function (_BaseClass) {
  function Banner(json) {
    var _this;
    Banner_classCallCheck(this, Banner);
    _this = Banner_callSuper(this, Banner);

    // default values
    _this.iconClass = "ion-md-megaphone";
    _this.isActive = true;
    _this.key = Date.now();
    if (json) mapJsonToBanner(json, _this);
    return _this;
  }
  Banner_inherits(Banner, _BaseClass);
  return Banner_createClass(Banner, [{
    key: "toJson",
    value: function toJson() {
      var json = {};
      if (this.id) json.Id = this.id;
      json.BannerType = this.bannerType;
      json.IsActive = this.isActive;
      json.Title = this.title;
      json.Text = this.text;
      json.HasButton = this.hasButton;
      json.ButtonLabel = this.buttonLabel;
      json.ButtonLink = this.buttonLink;
      json.IconClass = this.iconClass;
      return json;
    }
  }]);
}(BaseClass);

var mapJsonToBanner = function mapJsonToBanner(json, banner) {
  banner.bannerType = json.BannerType;
  banner.id = json.Id;
  banner.isActive = json.IsActive;
  banner.title = json.Title;
  banner.text = json.Text;
  banner.hasButton = json.HasButton;
  banner.buttonLabel = json.ButtonLabel;
  banner.buttonLink = json.ButtonLink;
  banner.iconClass = json.IconClass;
  banner.key = json.Id;
};
;// CONCATENATED MODULE: ./src/entities/index.js



















})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});